export const CrossIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10">
		<path
			fill="#fff"
			d="M4.969 4.24 8.286.927a.51.51 0 1 0-.724-.724L4.243 3.516.924.2a.51.51 0 1 0-.723.723L3.518 4.24.201 7.556a.51.51 0 1 0 .723.724l3.32-3.315L7.561 8.28a.509.509 0 0 0 .724 0c.201-.2.201-.525 0-.724L4.97 4.241Z"
		/>
	</svg>
);
